import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import remarkDialog from "../common/remarkDialog";
import settingDialog from "../common/settingDialog";
import recycleMsgDialog from "../common/recycleMsgDialog";
import recycleDialog from "../common/recycleDialog";

export default {
  mixins: [listMixin],
  components: {
    list, remarkDialog, settingDialog, recycleMsgDialog, recycleDialog
  },
  data() {
    return {
      wxApi: {
        order: require("@/api/wx/order").default,
        logistics: require('@/api/wx/logistics').default,
      },
      fullscreen: false,
      quickCheck: 0,
      temp: null,
      snField: "goodsName",
      snType: "DESC",
      sysType: "",
      mallToken: "", //店铺Token
      params: {
        goodsFilter: "",
        categoryName: "", //类目
        specFilter: "",
        hasRefund: null,
        buyerMemo: null,
        isRefund: null,
        area: "",
        areaCode: null,
        flag: null,
        expressName: null,
        fieldType: "sbSearch",
        fieldValue: "",
        timeType: "createTime",
        // startDate: this.$commonJs.getDayAgo(),
        // endDate: this.$commonJs.getToday(),
        startDate: null,
        endDate: null,
        orderStatusDesc: ""
      },
      categories: [],
      companiesList: [],
      mallList: [],
      ExpressList: []
    }
  },
  created() {
    this.sysType = "wx"; //localStorage.getItem("sys_type");
    // this.mallList = JSON.parse(localStorage.getItem("mall_list"));
    // this.mallToken = localStorage.getItem("token");
  },
  computed: {
    dataMasking() {
      return this.$store.state.settings.dataMasking;
    }
  },
  mounted() {
    // this.ExpressList.push({
    //   id: 1,
    //   name: "圆通快递",
    //   number: 3
    // })
    // this.ExpressList.push({
    //   id: 2,
    //   name: "中通快递",
    //   number: 4
    // })
    // this.ExpressList.push({
    //   id: 3,
    //   name: "韵达快递",
    //   number: 6
    // })

    // var loading = this.$loading({
    //   lock: true,
    //   text: "正在加载...",
    //   spinner: "el-icon-loading",
    //   customClass: "my_loading",
    //   background: "rgba(0, 0, 0, 0.3)",
    // });
    // var promises = [/*this.getCompanies(),*/this.getCategories()];
    // Promise.all(promises).then(res => {
    //   loading.close();
    //   var errlist = res.filter(x => x.errorCode != undefined)
    //   if (errlist.length > 0) this.$message.error(errlist.join("\n"));
    // }).catch(error => {
    //   console.log('All promises failed', JSON.parse(JSON.stringify(error)));
    //   loading.close();
    // });
  },
  methods: {
    reload() {
      this.$refs.list.reload();
    },
    setScreen() {
      this.$refs.list.setScreen();
      this.fullscreen = this.$refs.list.fullscreen;
    },
    setStyle() {
      this.$refs.list.data.forEach(x => {
        if (x.multiorder.length > 1) {
          x.multiorder.forEach(o => {
            var goods = document.getElementById("order_" + o.id);
            var height = goods.clientHeight + "px"
            var time = document.getElementById("time_" + o.id);
            if (time) time.style.height = height;
            var remark_ = document.getElementById("remark_" + o.id);
            if (remark_) remark_.style.height = height;
            var mall = document.getElementById("mall_" + o.id);
            if (mall) mall.style.height = height;
          })
        }
      })
    },
    setUnlock(data, type) {
      console.log("解锁")
      this.$confirm('确认解锁吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (!data.decryptData[type]) {
          this[this.sysType + "Api"].order.decrypt([data.orderNumber], this.mallToken).then(res => {
            if (res.data) {
              data.decryptData.fullName = res.data[0].receiverAddress.fullName;
              data.decryptData.mobilePhone = res.data[0].receiverAddress.mobilePhone;
              data.decryptData.address = res.data[0].receiverAddress.address;
              data.receiverAddress[type] = data.decryptData[type];
            } else {
              this.$message.error(res.errorMessage || "订单解密失败")
            }
          })
        } else {
          data.receiverAddress[type] = data.decryptData[type];
        }
      }).catch(() => { });
    },
    // getCategories() {
    //   return new Promise((resolve, reject) => {
    //     this[this.sysType + "Api"].order.getCategories().then(res => {
    //       this.categories = res;
    //       resolve(res);
    //     }).catch((err) => {
    //       reject(err)
    //     })
    //   })
    // },
    getCompanies() {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].logistics.companies(this.mallToken).then(res => {
          if (!res.errorCode) this.companiesList = res.data;
          resolve(res);
        }).catch((err) => {
          reject(err)
        })
      })
    },
    onQuickCheck(e) {
      if (e == 1) {
        var list = this.$refs.list.data;
        this.$refs.list.setCheckRows(list, true);
      } else {
        this.$refs.list.setCheckRows();
        // if (e == 0) {

        // }
      }
    },
    onAddressSelect(e) {
      console.log("地区选择", e);
      var area = e.find(x => x.children == null);
      console.log("area", area);
      this.params.areaCode = area.value;
    },
    openSetting() {
      this.$refs.settingDialog.open();
    },
    moreAction(command) {
      console.log("moreAction", command);
      this[command]();
    },
    //批量修改备注
    batchEditRemark() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      let ids = rows.map((item) => item.Id);
      this.$refs.remarkDialog.openEdit({ ids: ids });
    },
    //批量回收单号
    batchRecycleNumber() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      console.log("批量回收单号");
    },
    //批量锁定
    batchLock() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }

      var data = { ids: [], isLock: true, }
      rows.forEach(x => {
        var ids = x.multiorder.map(o => o.id);
        data.ids = data.ids.concat(ids);
      })
      console.log("批量锁定", data);
      this.setLock(data).then(res => {
        this.$message.success("设置成功");
        this.reload();
      });
    },
    //批量解锁
    batchUnlock() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }

      var data = { ids: [], isLock: false, }
      rows.forEach(x => {
        var ids = x.multiorder.map(o => o.id);
        data.ids = data.ids.concat(ids);
      })
      console.log("批量解锁", data);
      this.setLock(data).then(res => {
        this.$message.success("设置成功");
        this.reload();
      });
    },
    setLock(data) {
      return new Promise((resolve, reject) => {
        console.log("data", data);
        this[this.sysType + "Api"].order.saveLock(data).then(res => {
          resolve(res)
        })
      })
    },
    //批量合并订单
    batchConsolidateOrders() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      console.log("批量合并订单");
    },
    onSnUp() {
      console.log("up", this.$route.path)
      this.snType = "ASC";
      this.$refs.list.getData()
    },
    onSnDown() {
      console.log("down")
      this.snType = "DESC";
      this.$refs.list.getData()
    },
    editRemark(data) {
      this.$refs.remarkDialog.openEdit({ ids: [data.id], buyerMemo: data.buyerMemo, remark: data.remark });
    },
    onRecycle(row) {
      var loading = this.$loading({
        lock: true,
        text: "正在回收...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      setTimeout(() => {
        loading.close();
        var data = { success: 3, error: [] }
        if (row.Id == 4) {
          data.error.push({
            no: "463448272394581",
            msg: "更新或取消面单失败，面单已经被揽收、签收、或回收",
          })
          this.$refs.recycleMsgDialog.open().then(that => {
            that.setData(data)
          });
        } else {
          var msg = `共计回收<span style="color: #67C23A;margin: 0 5px;">${data.success}</span>个。`
          this.$alert(msg, '回收成功', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            callback: action => {
              this.reload();
            }
          });
        }
      }, 1000);
    },
    onCopy(row) {
      navigator.clipboard.writeText("test").then(() => {
        this.$message.success('复制成功');
      }).catch(err => {
        console.log('复制失败', err);
        this.$message.error('复制失败');
      });
    },
    showRecycle(row) {
      this.$refs.recycleDialog.open().then(that => {
        that.getData(row)
      });
    },
  }
}